export const TWILIO_SENDGRID_LOGO = "https://uiux-assets.sendgrid.com/logo/sg-twilio-logo-2025.svg";
export const LOGO_ALT = "Twilio SendGrid Logo";
